import { render } from "./AddButton.vue?vue&type=template&id=28ed7c82&scoped=true"
import script from "./AddButton.vue?vue&type=script&lang=js"
export * from "./AddButton.vue?vue&type=script&lang=js"

import "./AddButton.vue?vue&type=style&index=0&id=28ed7c82&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ed7c82"]])

export default __exports__